import { render, staticRenderFns } from "./TraxUiLoaderOverlay.vue?vue&type=template&id=7f77bb02"
import script from "./TraxUiLoaderOverlay.vue?vue&type=script&lang=js"
export * from "./TraxUiLoaderOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports